import React from 'react';
import { useSelector } from 'react-redux';
import { selectUserType } from '../../redux/slices/authSlice';
import LawyerDashboard from '../LawyerDashboard/LawyerDashboard';
import ClientDashboard from '../ClientDashboard/ClientDashboard';

const Dashboard = () => {
  const userType = useSelector(selectUserType);

  // Renderizar el dashboard correcto según el tipo de usuario
  if (userType === 'lawyer') {
    return <LawyerDashboard />;
  } else if (userType === 'client') {
    return <ClientDashboard />;
  }

  // Fallback si no hay userType todavía
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Cargando dashboard...</p>
      </div>
    </div>
  );
};

export default Dashboard;
